/**
 * Адреса страниц кейсов: id кейса → хвост адреса /keysy/<slug>.
 *
 * Только данные, без импортов — как section-paths.ts: их читают и
 * src/i18n/locale.ts (переключатель языка), и routes.tsx, и данные кейсов,
 * без циклической зависимости.
 *
 * Хвост — транслит по главному запросу страницы (Яндекс читает URL вместе с
 * title). Для именованных кейсов до эпохи ИИ — имя компании: по нему ищут.
 * Id совпадает с якорем карточки на /keysy (#cosmetics…): старые ссылки
 * с якорем продолжают вести на карточку кейса на хабе.
 */
export const CASE_SLUGS = {
  fences: 'vnedrenie-ii-proizvodstvo-zaborov',
  cosmetics: 'vnedrenie-ii-seller-wildberries-ozon',
  transport: 'vnedrenie-ii-taksopark-arenda-avto',
  'neftegaz-trade': 'vnedrenie-ii-neftegaz-proizvodstvo-torgovlya',
  novavi: 'novavi',
  roofmaster: 'roofmaster',
  drivemax: 'drivemax',
  marposadkabel: 'marposadkabel',
  'karate-sushi': 'karate-sushi',
  'crypto-exchange': 'kripto-birzha',
} as const

export type CaseId = keyof typeof CASE_SLUGS

/** Путь русской страницы кейса: /keysy/<slug>. */
export function casePath(id: CaseId): string {
  return `/keysy/${CASE_SLUGS[id]}`
}

/** Все пути страниц кейсов без локали — для LOCALIZED_PATHS и маршрутов. */
export const CASE_PATHS: string[] = (Object.keys(CASE_SLUGS) as CaseId[]).map(casePath)
